import axios from "axios";

export const proceed =
    (
        appFiles,
        fieldsState,
        additionalInformation,
        orderSummary,
        currency,
        total,
        stopLoading
    )=>{

    const form_data = new FormData();
    form_data.append('action', 'receive_abra_app_post');
    form_data.append('nonce', abraSiteNonce);
    form_data.append('order', orderSummary);
    form_data.append('information', additionalInformation);
    form_data.append('currency', currency);
    form_data.append('total', total);

    for(var x = 0; x < appFiles.length; x++) {
        form_data.append('file'+x, appFiles[x])
    }
    axios.post(abraSiteUrl, form_data, {})
        .then(res => { // then print response status
            stopLoading();
            const errors = ["nonce error","wrong type","exceeded size"];

            if(res.status !== 200 || errors.includes(res.data)){
                if(["wrong type","exceeded size"].includes(res.data)) alert(abraStr.serverFileError);
                else alert(abraStr.serverError);
                return;
            }
            //console.log(res.data);
            //console.log(res.statusText);
            const id = res.data;
            const {country, docEmail, docFirsName, docLastName} = fieldsState;
            const currencyId = currency === "dollars"? 2 : 0;
            const iCountBase = "https://app.icount.co.il/m/63983/";
            const url1 = `${iCountBase}?m__cart_id=${id}&ccfname=${docFirsName}&cclname=${docLastName}&customer_country=${country}`;
            const url2 = `&currency_id=${currencyId}&cs=${total}&cd=${abraStr.icountDescription}&contact_email=${docEmail}`;

            window.location = `${iCountBase}${url1}${url2}`;
        })

}